"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (palette) {
  return {
    h6: {
      fontSize: '1.25rem',
      letterSpacing: '0.015625rem'
    },
    subtitle1: {
      letterSpacing: '0.03125rem'
    },
    subtitle2: {
      letterSpacing: '0.00625rem'
    },
    body1: {
      letterSpacing: '0.01875rem'
    },
    button: {
      letterSpacing: '0.078125rem'
    },
    fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(',')
  };
};